

























































































import ConfirmModal from "@/components/ConfirmModal.vue";
import { Vue, Component, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import { GeneralSetting, generalSettings } from "../models/Setting";
import { camelToUnderscore, capitalize } from "../utils/Typography";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import GeneralSettingsMixin from "../mixins/http/GeneralSettingsMixin";
import CreateModal from "@/components/GeneralSettings/Create.vue";
import EditModal from "@/components/GeneralSettings/Edit.vue";
import { showToast } from "../utils/RailsRoutes";
import { httpStore } from "@/store/typed";

@Component({
  components: {
    Page,
    Paginator,
    DataTable,
    ConfirmModal,
    CreateModal,
    EditModal,
  },
})
export default class GeneralSettings extends Mixins(GeneralSettingsMixin) {
  selectedItem = null;
  items: GeneralSetting[] = [];

  mounted() {
    if (this.section) {
      this.selectedItem = this.settingTypes.find(
        (o) => camelToUnderscore(o.type) === this.section
      );
    } else {
      this.selectedItem = this.settingTypes[0];
    }

    this.loadSetting();
  }

  get columns() {
    let columns = [
      { name: "fullName", label: "Name" },
      { name: "shortName", label: "Code" },
    ];
    if (this.section === "currencies") {
      columns.push(
        ...[
          { name: "symbol", label: "Symbol" },
          { name: "conversion", label: "Conversion" },
        ]
      );
    }
    if (this.section === "measurement_units") {
      columns.push(...[{ name: "decimalCount", label: "Decimals" }]);
    }
    columns.push({ name: "actions", label: "Actions" });
    return columns;
  }

  get confirmModalName() {
    return `confirm_${this.section}_deletion_modal`;
  }

  get createModalName() {
    return `create_${this.section}_modal`;
  }

  get editModalName() {
    return `edit_${this.section}_modal`;
  }

  destroyTag(value) {
    return `destroy_${this.section}_${value.id}_tag`;
  }

  get loading() {
    return this.indexRequest?.loading;
  }

  get createTag() {
    return `create_${this.section}_tag`;
  }

  updateTag(value) {
    return `update_${this.section}_${value.id}_tag`;
  }

  get settingTypes() {
    return [...generalSettings];
  }

  get indexTag() {
    return `get_${this.section}_tag`;
  }

  get indexRequest() {
    return httpStore.status[this.indexTag];
  }

  get section(): string {
    return this.$route.params.section as string;
  }

  get settingType() {
    return this.settingTypes.find(
      (o) => camelToUnderscore(o.type) === this.section
    );
  }

  get confirmModalTitle() {
    return `Delete ${this.settingType?.name?.toLowerCase() || "resource"}`;
  }

  get createModal() {
    return this.$refs[this.createModalName] as CreateModal;
  }

  get editModal() {
    return this.$refs[this.editModalName] as EditModal;
  }

  openCreateModal() {
    this.createModal.create();
  }

  async onDestroyClicked(value: GeneralSetting) {
    const confirmed = await (this.$refs[this.confirmModalName] as any).confirm(
      `Are you sure you want to delete ${value.fullName}?`
    );
    const tag = this.destroyTag(value);
    if (confirmed) {
      this.destroySetting(this.section, value.id, tag).then(
        (resp) => {
          this.items = this.items.filter((o) => o.id !== resp.id);
          showToast(`${value.fullName} deleted successfully`);
        },
        (err) => {}
      );
    }
  }

  onPageChange(page) {
    this.loadSetting(page);
  }

  onEditClicked(value) {
    this.editModal.edit(value);
  }

  async onAdd(prototype: any) {
    try {
      const resp = await this.createSetting(
        this.section,
        prototype,
        this.createTag
      );
      this.items.unshift(resp);
      showToast(`${capitalize(this.settingType.name)} created successfully`);
      this.createModal.hide();
      this.createModal.reset();
    } catch (e) {
      showToast(
        `An error occurred while updating ${capitalize(this.settingType.name)}`,
        { type: "error" }
      );
    }
  }

  onEdit(value) {
    const tag = this.updateTag(value);
    const index = this.items.findIndex((o) => o.id === value.id);
    this.updateSetting(this.section, value, tag).then(
      (resp) => {
        showToast(`${capitalize(this.settingType.name)} updated successfully`);
        Vue.set(this.items, index, resp);
        this.editModal.hide();
      },
      (err) => {
        showToast(
          `An error occurred while updating ${capitalize(
            this.settingType.name
          )}`,
          { type: "error" }
        );
      }
    );
  }

  loadSetting(page = 1) {
    this.getSettings(this.section, { page: page }, this.indexTag).then(
      (resp) => {
        this.items = resp;
      },
      (err) => {}
    );
  }
}
